import React from "react";

const FLOATING_STYLE = { position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 100 };
const CLOSE_STYLE = {
    position: "absolute",
    top: -40,
    right: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    padding: 0,
    border: "1px solid rgba(255, 255, 255, 0.24)",
    borderRadius: "50%",
    background: "rgba(24, 24, 28, 0.56)",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.24)",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    color: "#fff",
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
};

function CloseButton({ onClick }) {
    return (
        <button type="button" aria-label="Закрыть рекламу" style={CLOSE_STYLE} onClick={onClick}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
            </svg>
        </button>
    );
}

export function FloatingFrame({ closable = false, onClose, children }) {
    return (
        <div style={FLOATING_STYLE}>
            {closable && <CloseButton onClick={onClose} />}
            {children}
        </div>
    );
}

export default FloatingFrame;
